import React from "react";
import img from "../../assets/images/Official.png";

function CardlyBlack() {
  return <img width={139} src={img} alt="Cardlylogo" />;
}

export default CardlyBlack;
